import { defineStore } from "pinia";
export const useReleasesStore = defineStore("releasesStore", {
  state: () => ({
    releases: [],
    currentPage: 1,
    lastPage: 1
  }),
  actions: {
    setReleases(releases) {
      this.releases = releases;
    },
    setPagination(currentPage, lastPage) {
      this.currentPage = currentPage;
      this.lastPage = lastPage;
    },
    updateRelease(release, updatedRelease) {
      const index = this.releases.findIndex((r) => r.id === release.id);
      this.releases[index] = updatedRelease;
    },
    archiveRelease(release) {
      const index = this.releases.findIndex((r) => r.id === release.id);
      this.releases.splice(index, 1);
    }
  }
});
